module.exports = __webpack_public_path__ + "static/media/audioIcon.b6741b3f.svg";